const addCountdownTimer = function() {
  const $countdownBanner = $('#home__countdown');
  if ($countdownBanner.length < 1) {
    return;
  }

  const $countdown = $('<div />', {
    class: 'countdown__clock'
  });
  
  $countdownBanner.append($countdown);
  // Set the date we're counting down to
  const countDownDate = new Date("Apr 12, 2025 09:00:00").getTime();
  
  // Update the count down every 1 second
  const x = setInterval(function() {
    // Get today's date and time
    const now = new Date().getTime();
  
    // Find the distance between now and the count down date
    const distance = countDownDate - now;
    
    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    if (distance < 0) {
      days = 0;
      hours = 0;
      minutes = 0;
      seconds = 0;
    }
    
    $countdown.html(`<span>${days}<small>days</small></span><span>${hours}<small>hours</small></span><span>${minutes}<small>mins</small></span><span>${seconds}<small>secs</small></span>`);
  
    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
    }
  }, 1000);
};

addCountdownTimer();